import { ITitrateState } from '../../procedures/titrate/store/titrate.types'
import { IItem } from '../../timeline/store/timeline.types'
import { IEKGEvent } from '../store/ekgImport.types'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { TimelineConstants } from '../../timeline/store/timeline.constants'

interface CreateTitrateProcedureProps {
  procedureEvent: IEKGEvent
  ptaCutoff: Date | null
}

export interface TitrateProcedureObject {
  timelineItem: IItem
  titrateState: ITitrateState
}

const createTitrateProcedure = (props: CreateTitrateProcedureProps): TitrateProcedureObject => {
  const { procedureEvent, ptaCutoff } = props

  const clientEventId = (procedureEvent.eventVitals.clientEventId as number).toString()
  const vsAction = procedureEvent.eventVitals.vsAction
  const isEkgImport = procedureEvent.eventVitals.isEkgImport

  const itemComments = procedureEvent.procedureComments || ''
  const eventSubHeader = `By , Medication: , Route: , New Dose/ Rate: , Comments: ${itemComments}.`

  const eventDate = new Date(procedureEvent.dtDevice)
  const isPTA = !!ptaCutoff && eventDate < ptaCutoff

  const timelineItem: IItem = {
    key: clientEventId,
    itemType: 'Procedures',
    event: 'Titrate',
    grid: true,
    labelHeaderFlag: isPTA ? 'PTA' : '',
    labelHeader: procedureEvent.eventVitals.time,
    subHeader: procedureEvent.eventVitals.date,
    eventSubHeader: eventSubHeader,
    rowActionType: TimelineConstants.SET_TITRATE_PROCEDURE_ITEM,
    defaultHref: TabConstants.TITRATE_PROCEDURE,
    date: new Date(procedureEvent.dtDevice),
    clientEventId: clientEventId,
    ...(vsAction && { vsAction: vsAction }),
    ...(isEkgImport && { isEkgImport: isEkgImport }),
  }

  const titrateState: ITitrateState = {
    key: clientEventId,
    date: procedureEvent.eventVitals.date,
    time: procedureEvent.eventVitals.time,
    pta: isPTA,
    assessedBy: null,
    rolePerforming: null,
    rolePerformingPNNV: null,
    medication: null,
    otherOption: '',
    newDose: '',
    rate: null,
    ratePNNV: null,
    route: null,
    routePNNV: null,
    procedureComplications: [],
    response: null,
    responsePNNV: null,
    authorization: null,
    comments: itemComments,
    updateInputRows: false,
    addToTimeline: true,
    type: 'Titrate',
    isEkgImport: 1,
    nemsisCode: null,
    procedurePerformedByAnotherUnit: null,
    procedurePerformedByAnotherUnitPNNV: null,
  }

  const newTitrateProcedureObject: TitrateProcedureObject = {
    titrateState,
    timelineItem,
  }

  return newTitrateProcedureObject
}

export default createTitrateProcedure
